export function libraryCategoriesListSelector(state) {
  const ids = libraryCategoriesListStateSelector(state).items
  return ids.map((id) => state.local.libraryCategories.entities[id])
}

export function libraryCategoriesListStateSelector(state) {
  return state.local.libraryCategories.list
}
